module.exports = __webpack_public_path__ + "static/fk-3c219c646e6cd261ec3f30213d8c0660.svg";